module.exports = __webpack_public_path__ + "static/flags/EK-60bf74d4a3cd72c5c95170c3880625f8.gif";